(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["markiewka-cart-promotions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('markiewka-cart-promotions')) {
  customElements.define('markiewka-cart-promotions', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelectorAll('[data-copy]').forEach((button) => {
        button.addEventListener('click', async () => {
          const offer = button.closest('article');
          const input = offer.querySelector('input[readonly]');
          const status = offer.querySelector('[role="status"]');
          let copied = false;
          try { await navigator.clipboard.writeText(button.dataset.copy); copied = true; }
          catch {
            input.focus({ preventScroll: true });
            input.select();
            input.setSelectionRange(0, input.value.length);
            try { copied = document.execCommand('copy'); } catch {}
          }
          button.textContent = copied ? 'Skopiowano ✓' : 'Kopiuj kod';
          status.textContent = copied ? 'Dodaj produkt do koszyka i wklej kod przy składaniu zamówienia. Wybierz tylko 1 promocję.' : 'Przytrzymaj zaznaczony kod i wybierz „Kopiuj”.';
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["markiewka-curuba-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('markiewka-curuba-gift')) {
  class MarkiewkaCurubaGift extends HTMLElement {
    static pending = false;
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      try {
        if (this.dataset.confirmed === 'true') sessionStorage.setItem('mk-curuba-newsletter', '1');
        if (sessionStorage.getItem('mk-curuba-newsletter') === '1') this.hidden = false;
      } catch {}
      this.querySelector('[data-mk-add-gift]')?.addEventListener('click', () => this.redeem());
    }
    async redeem() {
      if (MarkiewkaCurubaGift.pending) return;
      MarkiewkaCurubaGift.pending = true;
      const button = this.querySelector('[data-mk-add-gift]');
      const error = this.querySelector('[role="alert"]');
      const label = button.textContent;
      button.disabled = true;
      button.textContent = this.dataset.busy;
      error.hidden = true;
      const root = this.dataset.root;
      try {
        const cartResponse = await fetch(root + 'cart.js', {headers: {'Accept':'application/json'}});
        if (!cartResponse.ok) throw new Error();
        const cart = await cartResponse.json();
        const existing = cart.items.filter(item => String(item.variant_id) === this.dataset.variantId)
          .reduce((sum, item) => sum + item.quantity, 0);
        const missing = Math.max(0, 4 - existing);
        if (missing > 0) {
          const addResponse = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json', 'Accept':'application/json'},
            body: JSON.stringify({items:[{id:this.dataset.variantId, quantity:missing}]})
          });
          if (!addResponse.ok) throw new Error();
        }
        const codes = [...new Set([...(cart.discount_codes || []).map(item => item.code), this.dataset.code])];
        const discountResponse = await fetch(root + 'cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({discount:codes.join(',')})
        });
        if (!discountResponse.ok) throw new Error();
        window.location.assign(root + 'cart');
      } catch {
        error.textContent = this.dataset.error;
        error.hidden = false;
        button.disabled = false;
        button.textContent = label;
      } finally {
        MarkiewkaCurubaGift.pending = false;
      }
    }
  }
  customElements.define('markiewka-curuba-gift', MarkiewkaCurubaGift);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["markiewka-promotions"] && !Shopify.designMode) return;
  try {
    function setupMarkiewkaPromotions() {
  const dialog = document.getElementById('MkPromotionsDialog');
  const open = document.querySelector('[data-mk-promotions-open]');
  if (!dialog || !open || open.dataset.ready) return;
  open.dataset.ready = 'true';
  document.body.appendChild(dialog);
  document.querySelectorAll('[data-mk-promotions-open]').forEach((button) => {
    button.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
  });
  dialog.querySelectorAll('[data-mk-copy-code]').forEach((button) => {
    button.addEventListener('click', async () => {
      const input = button.parentElement.querySelector('input');
      const status = button.parentElement.querySelector('[role="status"]');
      let copied = false;
      try {
        await navigator.clipboard.writeText(button.dataset.mkCopyCode);
        copied = true;
      } catch {
        input.focus({ preventScroll: true });
        input.select();
        input.setSelectionRange(0, input.value.length);
        try { copied = document.execCommand('copy'); } catch {}
      }
      if (copied) {
        button.textContent = 'Skopiowano ✓';
        status.textContent = 'Kod skopiowany. Pamiętaj: dodaj produkt promocyjny do koszyka i wklej kod przy składaniu zamówienia.';
        button.focus({ preventScroll: true });
      } else {
        status.textContent = 'Przytrzymaj zaznaczony kod i wybierz „Kopiuj”.';
      }
    });
  });
  dialog.querySelectorAll('a[href="#MarkiewkaNewsletter"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const form = document.getElementById('MarkiewkaNewsletter');
      if (!form) return;
      event.preventDefault();
      dialog.close();
      requestAnimationFrame(() => {
        form.style.scrollMarginTop = 'calc(var(--header-height, 100px) + 24px)';
        form.scrollIntoView({ block: 'center', behavior: 'instant' });
        form.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      });
    });
  });
  dialog.querySelector('[data-mk-promotions-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
}
setupMarkiewkaPromotions();
document.addEventListener('shopify:section:load', setupMarkiewkaPromotions);
  } catch(e) { console.error(e); }
})();

})();
